import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import styles from './HeroSection.module.css';
import type { HeroSectionProps } from './types';
function HeroImage(t0) {
  const $ = _c(2);
  const {
    image
  } = t0;
  let t1;
  if ($[0] !== image) {
    t1 = <div className={styles.heroImageOuterContainer}><div className={styles.heroImageInnerContainer}><Image src={image} alt="" width={530} height={276} className={styles.headerImage} priority={true} loading="eager" /></div></div>;
    $[0] = image;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export default HeroImage;